import { z } from 'zod';
import { FocusArea } from 'libs/end-to-end/src/focus-area';

export const DynamicPipelineAnalysisDemographicData = z
  .object({
    name: z.string(),
    count: z.coerce.number(),
    ratio_of_group: z.coerce.number(),
    ratio_of_event: z.coerce.number(),
  })
  .describe('DynamicPipelineAnalysisDemographicData');

export type DynamicPipelineAnalysisDemographicData = z.infer<
  typeof DynamicPipelineAnalysisDemographicData
>;

export const DynamicPipelinePhaseResult = z
  .object({
    total: z.coerce.number(),
    avg_ratio_of_event: z.coerce.number(),
    demographic_data: z.array(DynamicPipelineAnalysisDemographicData),
    name: z.string(),
    custom_name: z.string().optional(),
  })
  .describe('DynamicPipelinePhaseResult');

export type DynamicPipelinePhaseResult = z.infer<
  typeof DynamicPipelinePhaseResult
>;

export const DynamicPipelinePhaseDetails = z
  .object({
    positive_result: DynamicPipelinePhaseResult,
    negative_result: DynamicPipelinePhaseResult,
    focusArea: FocusArea,
    metric: z.string(),
  })
  .describe('DynamicPipelinePhaseDetails');

export type DynamicPipelinePhaseDetails = z.infer<
  typeof DynamicPipelinePhaseDetails
>;

export const DynamicPipelineAnalysisOutput = z
  .object({
    name: z.string(),
    phases: z.array(DynamicPipelinePhaseDetails),
    firstPhase: DynamicPipelinePhaseResult,
    dimension: z.string(),
  })
  .describe('DynamicPipelineAnalysisOutput');

export type DynamicPipelineAnalysisOutput = z.infer<
  typeof DynamicPipelineAnalysisOutput
>;

export const DynamicPipelineAnalysisSerializableProps = z.object({
  pipelineAnalysisOutput: DynamicPipelineAnalysisOutput,
  selectedLevel: z.string(),
});

export type DynamicPipelineAnalysisSerializableProps = z.infer<
  typeof DynamicPipelineAnalysisSerializableProps
>;
